import { useMemo } from 'react';

import { useVisualLanguages } from 'src/services/useVisualLanguages';

export const useWithVisualLanguageInfo = (entities) => {
  const { workspaceVisualLanguages } = useVisualLanguages();

  return useMemo(() => {
    if (!entities) {
      return [];
    }
    if (!workspaceVisualLanguages) {
      return entities;
    }

    return entities.map((entity) => {
      const visualLanguage = workspaceVisualLanguages.find(
        (vl) => vl.id === entity.visualLanguageId
      );

      return {
        ...entity,
        visualLanguage: visualLanguage || null,
      };
    });
  }, [entities, workspaceVisualLanguages]);
};
